var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AsiChip',{attrs:{"small":_vm.small,"x-small":_vm.xSmall,"label":""},on:{"click":function($event){$event.stopPropagation();return _vm.copy.apply(null, arguments)}}},[_c('span',{staticClass:"mr-2 font-weight-bold"},[_vm._v(_vm._s(_vm.$t('item.terms.itemNumberDense')))]),_vm._v(" "+_vm._s(_vm.item.itemNumber)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }